import { render, staticRenderFns } from "./Viewper.vue?vue&type=template&id=1d394808&scoped=true"
import script from "./Viewper.vue?vue&type=script&lang=js"
export * from "./Viewper.vue?vue&type=script&lang=js"
import style0 from "./Viewper.vue?vue&type=style&index=0&id=1d394808&prod&scoped=true&lang=css"
import style1 from "./Viewper.vue?vue&type=style&index=1&id=1d394808&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d394808",
  null
  
)

export default component.exports